export enum ActionTypeEnum {
    Info = "info",
    Danger = "danger",
}

export interface IAction {
    icon?: string;
    title: string;
    type: ActionTypeEnum;
    event: () => void;
}

export type IActions = IAction[];
